// extracted by mini-css-extract-plugin
export default {"quoteContainer":"QuoteOfTheDay_quoteContainer__XAZjS","quote":"QuoteOfTheDay_quote__LHX7p","author":"QuoteOfTheDay_author__gLWj0"};